// HSA/FSA landing page interactivity: carousel + accordion
(function () {
  // ---------- Accordions ----------
  document.querySelectorAll('[data-accordion]').forEach(function (root) {
    root.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.accordion-item');
        var willOpen = !item.classList.contains('is-open');
        // single-collapsible behavior: close siblings within this group
        root.querySelectorAll('.accordion-item.is-open').forEach(function (other) {
          other.classList.remove('is-open');
          var t = other.querySelector('.accordion-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  // ---------- Carousel ----------
  var carousel = document.querySelector('[data-carousel]');
  if (!carousel) return;
  var track = carousel.querySelector('.carousel-track');
  var slides = carousel.querySelectorAll('.slide');
  var prev = carousel.querySelector('.carousel-prev');
  var next = carousel.querySelector('.carousel-next');
  var index = 0;

  function perView() {
    return window.matchMedia('(min-width: 1280px)').matches ? 2 : 1;
  }
  function maxIndex() {
    return Math.max(0, slides.length - perView());
  }
  function update() {
    if (index > maxIndex()) index = maxIndex();
    if (index < 0) index = 0;
    var slide = slides[0];
    var slideW = slide.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
    track.style.transform = 'translateX(' + (-(slideW + gap) * index) + 'px)';
    prev.disabled = index === 0;
    next.disabled = index >= maxIndex();
  }
  prev.addEventListener('click', function () { index -= 1; update(); });
  next.addEventListener('click', function () { index += 1; update(); });
  window.addEventListener('resize', update);
  // initial paint after fonts/layout settle
  requestAnimationFrame(update);
  window.addEventListener('load', update);
})();
